export default __webpack_public_path__ + "static/media/pencil-alt.97b0f6f8.svg";